/* eslint-disable max-len */
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { EStavZadosti, IZadostResp, nzUcet } from 'services/nezarazenyUcet/nuZapis';

interface IBIPOSK {
    zadostData?: IZadostResp;
    setZadostData: React.Dispatch<React.SetStateAction<IZadostResp | undefined>>;
}

const BIPOSK: React.FC<IBIPOSK> = props => {
    const history = useHistory();
    const [form] = useForm();
    const { zadostData, setZadostData } = props;
    const [errStatus, setErrStatus] = useState<number>();
    const [valsErr, setValsErr] = useState<boolean>();
    const [loading, setLoading] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>();

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    console.log('asrfasf');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        setLoading(true);
        setValsErr(false);
        nzUcet(fieldsValue.ucet, token)
            .then(resp => {
                resp.existuje
                    ? setZadostData(pv => {
                          return {
                              ...pv,
                              rcma: fieldsValue.ucet,
                              stav: EStavZadosti.UCDAL
                          };
                      })
                    : setValsErr(true);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : (
                <LoadingWrapper loading={loading}>
                    <FormWrapper
                        onFinish={onFinish}
                        requiredMark={false}
                        colon={false}
                        outForm={form}
                        labelAlign="left"
                        layoutPosition="horizontal"
                    >
                        <h3>
                            <TranslateText>Zadejte číslo majetkového účtu</TranslateText>
                        </h3>
                        <InputComponent
                            labelCol={{
                                span: 8
                            }}
                            labelTextMaxWidth={300}
                            className="label-long"
                            name="ucet"
                            label="Vložte číslo účtu majitele (naleznete na výpise z nezařazeného účtu)"
                            // initialValue={zadostData?.bankucty![0].ciuc ? zadostData?.bankucty[0].ciuc : ''}
                            // disabled={true}
                        />
                        <Row className="statement-buttons-row">
                            <ButtonComponent htmlType="submit" buttontext="POKRACOVAT" />
                        </Row>
                        {valsErr && (
                            <>
                                <Row>
                                    <Paragraph
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                        text="Vámi uvedené číslo účtu v nezařazené evidenci není v Centrálním depozitáři cenných papírů evidováno. Zadané číslo účtu nebylo k Vámi poskytnuté identifikaci nalezeno."
                                    />
                                </Row>
                                <Row>
                                    <Paragraph text="Číslo nezařazeného majetkového účtu zjistíte na výpise z majetkového účtu. Pokud chcete požádat o výpis z nezařazeného majetkového účtu, služba je dostupná" />
                                    <a
                                        style={{
                                            marginLeft: 4
                                        }}
                                        onClick={() => window.open('/nezarazeny-ucet-bankid/', '_parent')}
                                    >
                                        zde.
                                    </a>
                                </Row>
                                <Row>
                                    <Paragraph text="Pro opakované dokončení žádosti Zápisu změny údajů evidovaných o majiteli nezařazeného účtu použijte link, který Vám byl zaslán v emailu Potvrzení o zaplacení žádosti – Zápis změny údajů o majiteli nezařazeného účtu. " />
                                </Row>
                            </>
                        )}
                    </FormWrapper>
                </LoadingWrapper>
            )}
        </>
    );
};

export default BIPOSK;
